import React, { useState } from "react";
import Table from "../../Common/Table";
import Pagination from "../../Common/Pagination";
import useAddRoles from "./useAddRoles";
import AddRolesForm from "./AddRolesForm";

const AddRoles = () => {
    const {
        columns,
        currentRows,
        totalRows,
        currentPage,
        rowsPerPage,
        handlePageChange,
        handleRowsPerPageChange,
        fetchRoles,
        loading
      } = useAddRoles();
        const [isModalOpen, setIsModalOpen] = useState(false);
       
        // Function to toggle the modal
        const toggleModal = () => {
          setIsModalOpen(!isModalOpen);
        };

  return (
    <div className="flex flex-col">
      <h1 className="main_heading text-2xl xl:text-[30px] mb-3">Roles</h1>
      <div className="flex justify-start ">
        <button
          onClick={toggleModal}
          className="bg-buttoncolor text-white font-medium text-center text-sm xl:text-base py-2 rounded-lg w-[120px] lg:w-[139px]"
        >
          Add Role
        </button>
        <AddRolesForm
        isOpen={isModalOpen}
        onClose={toggleModal}
        fetchRoles={fetchRoles}
        />
      </div>
      {loading ? (
        <div className="flex justify-center items-center my-4">
          <p className="text-green700 font-medium">Loading data...</p>
        </div>
      ) : (
      <div className="my-2 mb-6  overflow-auto horizontalscroll">
        <Table columns={columns} data={currentRows} />
      </div>
      )}
      {/* Pagination */}
      <Pagination
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
    </div>
  );
};

export default AddRoles;
